var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"uniltwebgl"},[_c('iframe',{staticClass:"unilt",attrs:{"src":_vm.url,"scrolling":"no","frameborder":"0"}}),_c('div',{staticClass:"back",on:{"click":_vm.back}},[_c('van-image',{attrs:{"width":"30","height":"30","src":_vm.btnImg}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }